var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "zoom", mode: "out-in" } }, [
    _c(
      "div",
      {
        staticClass: "root",
        class: {
          "modal-z-index": _vm.open,
          "extra-margin": _vm.isAtBottomOfWindow
        }
      },
      [
        _c("div", { staticClass: "header" }, [
          _c("h2", [
            _vm._v(
              "Olá" + _vm._s(_vm._f("formatFirstName")(_vm.firstName)) + "!"
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "schedule" },
          [
            _c("div", { staticClass: "text" }, [
              _vm._v("\n        Onde vamos limpar hoje?\n      ")
            ]),
            _vm._v(" "),
            _c("router-link", { attrs: { to: { name: "purchase-flow" } } }, [
              _c("div", { staticClass: "schedule-button" }, [
                _c("img", { attrs: { src: "/static/pin.svg" } }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n            Selecione o endereço da limpeza\n          "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.countOrdersNotProvided
              ? _c("div", { staticClass: "alert" }, [
                  _c("span", [
                    _c("img", {
                      attrs: { src: "/static/exclamation-triangle-solid.svg" }
                    }),
                    _vm._v("\n\n          Você possui "),
                    _c("b", [_vm._v(_vm._s(_vm.orderCount))]),
                    _vm._v(
                      " em crédito.\n          Entre em contato com o nosso suporte para realizar o reagendamento.\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "footer",
                      on: {
                        click: function($event) {
                          _vm.open = true
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v("reagendar limpeza")]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: { src: "/static/basic/arrow-next.svg" }
                      })
                    ]
                  )
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.open
          ? _c("NotProvidedPayablesList", {
              attrs: { orders: _vm.ordersNotProvided },
              on: {
                close: function($event) {
                  _vm.open = false
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f9cb258", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f9cb258","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/components/Welcome.vue
// module id = null
// module chunks = 